import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QualificationTrainingsStatus } from '@wilson/interfaces';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { QualificationTrainingStatusTagComponent } from '../../qualification-training-status-tag/qualification-training-status-tag.component';

@Component({
  selector: 'wilson-qualification-training-status-renderer',
  template: `
    <wilson-qualification-training-status-tag [status]="cellValue" />
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [QualificationTrainingStatusTagComponent],
})
export class QualificationTrainingStatusRendererComponent
  implements AgRendererComponent
{
  public cellValue!: QualificationTrainingsStatus;

  agInit(params: ICellRendererParams): void {
    this.cellValue = params.data?.status;
  }

  refresh(params: ICellRendererParams): boolean {
    this.cellValue = params.data?.status;
    return true;
  }
}
